import { UATConstants, HttpVerbs } from 'src/Common/Models/UATConstants';
import { ServiceFactoryClientExecuteApi } from 'src/Common/Services/ServiceFactoryToExecuteApi';
import ErrorResponse from 'src/Models/ErrorResponse';
import { appInsights } from 'src/Services/Insights';
import { IExceptionTelemetry, SeverityLevel } from '@microsoft/applicationinsights-web';
import {
  AnalyticsField,
  AnalyticsView,
  AnalyticsViewAreaPath,
  AnalyticsViews,
  ViewAnalyticsModel,
} from './AnalyticsModel';
import { SQLOperator } from 'src/Models/SQLInOperator';

export class AnalyticsActions {
  public static PostAnalyticsView(
    analyticsView: ViewAnalyticsModel,
    onRequestSuccess: (isSuccess: boolean) => void,
    onRequestFailure: (error: ErrorResponse) => void
  ) {
    const url = UATConstants.ApiPaths.AddAnalyticsView;
    ServiceFactoryClientExecuteApi.ExecuteAdoRequest<any>(
      url,
      [],
      HttpVerbs.post,
      analyticsView,
      (response: boolean) => onRequestSuccess(response),
      (response: ErrorResponse) => onRequestFailure(response),
      false
    );
  }

  public static VerifyAnalyticsView(
    analyticsView: ViewAnalyticsModel,
    onRequestSuccess: (isSuccess: any) => void,
    onRequestFailure: (error: ErrorResponse) => void
  ) {
    const url = '/api/GetVerificationDetail';
    ServiceFactoryClientExecuteApi.ExecuteAdoRequest<any>(
      url,
      [],
      HttpVerbs.post,
      analyticsView,
      (response: any) => onRequestSuccess(response),
      (response: ErrorResponse) => onRequestFailure(response),
      false
    );
  }

  public static UpdateAnalyticsView(
    analyticsView: ViewAnalyticsModel,
    viewId: string,
    onRequestSuccess: (isSuccess: boolean) => void,
    onRequestFailure: (error: ErrorResponse) => void
  ) {
    const url = `${UATConstants.ApiPaths.UpdateAnalyticsView}?viewId=${viewId}`;

    ServiceFactoryClientExecuteApi.ExecuteAdoRequest<any>(
      url,
      [],
      HttpVerbs.post,
      analyticsView,
      (response: boolean) => onRequestSuccess(response),
      (response: ErrorResponse) => onRequestFailure(response),
      false
    );
  }

  public static DeleteAnalyticsView(
    viewId: string,
    onRequestSuccess: (isSuccess: boolean) => void,
    onRequestFailure: (error: ErrorResponse) => void
  ) {
    const url = `${UATConstants.ApiPaths.DeleteAnalyticsView}?viewId=${viewId}`;

    ServiceFactoryClientExecuteApi.ExecuteAdoRequest<any>(
      url,
      [],
      HttpVerbs.post,
      [],
      (response: boolean) => onRequestSuccess(response),
      (response: ErrorResponse) => onRequestFailure(response),
      false
    );
  }

  public static GetAnalyticsViewFields(onRequestSuccess: (isSuccess: AnalyticsField[]) => void) {
    const url = UATConstants.ApiPaths.GetAnalyticsViewFields;
    ServiceFactoryClientExecuteApi.ExecuteAdoRequest<any>(
      url,
      [],
      HttpVerbs.post,
      '',
      (response: AnalyticsField[]) => onRequestSuccess(response),
      (response: ErrorResponse) => {
        this.logError(response);
      },
      false
    );
  }

  public static GetAnalyticsViewFieldValues(
    fieldName: string,
    onRequestSuccess: (isSuccess: string[]) => void
  ) {
    const url = `${UATConstants.ApiPaths.GetAnalyticsViewFieldValues}?fieldName=${fieldName}`;

    ServiceFactoryClientExecuteApi.ExecuteAdoRequest<any>(
      url,
      [],
      HttpVerbs.get,
      [],
      (response: string[]) => onRequestSuccess(response),
      (response: ErrorResponse) => {
        this.logError(response);
      },
      false
    );
  }

  public static GetAnalyticsViewById(
    viewId: string,
    onRequestSuccess: (data: ViewAnalyticsModel) => void
  ) {
    const url = `${UATConstants.ApiPaths.GetAnalyticsViewById}?viewId=${viewId}`;

    ServiceFactoryClientExecuteApi.ExecuteAdoRequest<any>(
      url,
      [],
      HttpVerbs.get,
      [],
      (response: ViewAnalyticsModel) => onRequestSuccess(response),
      (response: ErrorResponse) => {
        this.logError(response);
      },
      false
    );
  }

  public static GetAnalyticsViewAreaPath(
    onRequestSuccess: (result: AnalyticsViewAreaPath[]) => void
  ) {
    const url = `${UATConstants.ApiPaths.GetAnalyticsViewAreaPath}`;

    ServiceFactoryClientExecuteApi.ExecuteAdoRequest<any>(
      url,
      [],
      HttpVerbs.get,
      [],
      (response: AnalyticsViewAreaPath[]) => onRequestSuccess(response),
      (response: ErrorResponse) => {
        this.logError(response);
      },
      false
    );
  }

  public static GetAnalyticsViewList(onRequestSuccess: (result: AnalyticsViews[]) => void) {
    const url = `${UATConstants.ApiPaths.GetAnalyticsViewList}`;

    ServiceFactoryClientExecuteApi.ExecuteAdoRequest<any>(
      url,
      [],
      HttpVerbs.get,
      [],
      (response: AnalyticsViews[]) => onRequestSuccess(response),
      (response: ErrorResponse) => {
        this.logError(response);
      },
      false
    );
  }

  public static logError = (errResponse: any) => {
    const exception: IExceptionTelemetry = {
      exception: errResponse,
      severityLevel: SeverityLevel.Error,
      properties: {
        name: 'AddAnalyticsViewCreateError',
        url: UATConstants.ApiPaths.AddAnalyticsView,
        userName: sessionStorage.getItem('jwtUserAccountName'),
        userAlias: sessionStorage.getItem('jwtUserAccountEmail'),
      },
    };
    appInsights.trackException(exception);
  };

  public static GetSQLOperators(): SQLOperator[] {
    return [
      { id: 0, sqlOperator: '=' },
      { id: 1, sqlOperator: '≠' },
      { id: 2, sqlOperator: '≥' },
      { id: 3, sqlOperator: '≤' },
      { id: 4, sqlOperator: '>' },
      { id: 5, sqlOperator: '<' },
      { id: 6, sqlOperator: 'Contains' },
      { id: 7, sqlOperator: 'Does not contain' },
      { id: 8, sqlOperator: 'Under' },
      { id: 9, sqlOperator: 'Not under' },
    ];
  }
}
